import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useReportTimezone } from 'dashboard/composables/useReportTimezone';
import { resolveShellPeriod, shellPeriodQuery } from '../helpers/reportsPeriod';

/**
 * O periodo da casa dos relatorios, lido da URL. So a casca (ReportsWrapper)
 * chama isto: ela escreve na URL e oferece o periodo as telas por
 * provide(REPORTS_SHELL_PERIOD); a tela le com useShellPeriod.
 */
export function useReportsPeriod() {
  const route = useRoute();
  const router = useRouter();
  const { reportTimezone } = useReportTimezone();

  const period = computed(() =>
    resolveShellPeriod(route.query || {}, reportTimezone.value)
  );
  const periodKey = computed(() => period.value.key);

  const setPeriod = next => {
    router.replace({
      name: route.name,
      params: route.params,
      query: {
        ...route.query,
        ...shellPeriodQuery(next, reportTimezone.value),
      },
    });
  };

  return { period, periodKey, setPeriod };
}
